import React from "react";
import { useSchedulingOrg } from "../../../../hooks/ReactQueryHooks/useSchedulingOrg";
import AppointmentsList from "./AppointmentsList";

const PatientAppointmentsTab = ({ patientId }) => {
  const { organizationRef } = useSchedulingOrg();
  if (!patientId) return null;
  return <AppointmentsList organizationRef={organizationRef} patientRef={patientId} sort="desc" />;
};

export default PatientAppointmentsTab;
